import { getLayerIds, isLayerSwitcherGroupState } from '@tmapy/config';
import { ADD_LAYER_SWITCHER_LAYERS, LAYER_SWITCHER_GROUP_TOGGLE, LAYER_SWITCHER_GROUP_VISIBILITY, LAYER_SWITCHER_SET_FILTER, SET_LAYER_SWITCHER_STATE, } from '../constants';
import { getInitialState } from './initialState';
const deriveExclusivityDisplay = (layers) => {
    const groupLayerIds = layers.reduce((acc, item) => [...acc, ...getLayerIds(item)], []);
    return layers.map((item) => {
        if (isLayerSwitcherGroupState(item)) {
            return {
                ...item,
                children: deriveExclusivityDisplay(item.children),
            };
        }
        const otherLayerIds = groupLayerIds.filter((groupLayerId) => groupLayerId !== item.layerId);
        const showExclusivity = item.exclusiveLayerIds?.some((exclusiveLayerId) => otherLayerIds.includes(exclusiveLayerId));
        return { ...item, showExclusivity };
    });
};
const validateLayerTree = (layers) => {
    const layerIds = layers.reduce((acc, item) => [...acc, ...getLayerIds(item)], []);
    const isDuplicateLayerid = layerIds.some((layerId, index) => layerIds.indexOf(layerId) !== index);
    if (isDuplicateLayerid) {
        throw new Error('A duplicate layer ID was found in the layer tree.');
    }
    return layers;
};
export const layerSwitcher = (state = getInitialState(), action) => {
    switch (action.type) {
        case SET_LAYER_SWITCHER_STATE: {
            return {
                ...action.payload,
                layers: validateLayerTree(deriveExclusivityDisplay(action.payload.layers)),
            };
        }
        case LAYER_SWITCHER_GROUP_TOGGLE: {
            const layerSwitcherGroupToggle = (item) => isLayerSwitcherGroupState(item)
                ? item.groupId === action.payload
                    ? {
                        ...item,
                        isExpanded: !item.isExpanded,
                    }
                    : {
                        ...item,
                        children: item.children.map(layerSwitcherGroupToggle),
                    }
                : item;
            return {
                ...state,
                layers: state.layers.map(layerSwitcherGroupToggle),
            };
        }
        case LAYER_SWITCHER_SET_FILTER: {
            if (!action.payload) {
                /**
                 * Disable filter and set all groups and layers visible
                 */
                const layerSwitcherSetVisible = (item) => isLayerSwitcherGroupState(item)
                    ? {
                        ...item,
                        isVisible: true,
                        children: item.children.map(layerSwitcherSetVisible),
                    }
                    : {
                        ...item,
                        isVisible: true,
                    };
                return {
                    ...state,
                    filter: {
                        ...state.filter,
                        value: null,
                    },
                    layers: state.layers.map(layerSwitcherSetVisible),
                };
            }
            const layerSwitcherFilter = (item) => isLayerSwitcherGroupState(item)
                ? {
                    ...item,
                    isVisible: action.payload.groupIds.includes(item.groupId),
                    children: item.children.map(layerSwitcherFilter),
                }
                : {
                    ...item,
                    isVisible: action.payload.layerIds.includes(item.layerId),
                };
            return {
                ...state,
                filter: {
                    ...state.filter,
                    value: action.payload.filter,
                },
                layers: state.layers.map(layerSwitcherFilter),
            };
        }
        case LAYER_SWITCHER_GROUP_VISIBILITY: {
            return {
                ...state,
                savedGroupVisibility: {
                    ...state.savedGroupVisibility,
                    ...action.payload,
                },
            };
        }
        case ADD_LAYER_SWITCHER_LAYERS: {
            return {
                ...state,
                layers: [...state.layers, ...action.payload],
            };
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=layerSwitcherReducer.js.map